import { render, staticRenderFns } from "./ProcessingStation.vue?vue&type=template&id=398faf51"
import script from "./ProcessingStation.vue?vue&type=script&lang=ts"
export * from "./ProcessingStation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports